import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "468",
  height: "653",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3643BA",
      d: "M0 0h468v653H0z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "476",
      cy: "469",
      r: "183.75",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "410",
      cy: "552",
      r: "183.75",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1)
  ]))]))
}
export default { render: render }